import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/member",
    name: "Member",
    component: () => import("../views/Member.vue"),
  },
  {
    path: "/about",
    name: "Company",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    meta: { requiresAuth: true },
    component: () => import("../views/Logout.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },

  /*******************
   * sales(sale)営業担当
   **/
  {
    path: "/sales",
    name: "SalesDashboard",
    component: () => import("../views/sales/Dashboard.vue"),
  },
  //
  // Member
  {
    path: "/sales/member",
    name: "SalesMemberList",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/member/Index.vue"),
  },
  {
    path: "/sales/member/create",
    name: "SalesMemberCreate",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/member/Create.vue"),
  },
  {
    path: "/sales/member/:member_id",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/member/_id/Index.vue"),
    children: [
      {
        path: "/",
        name: "SalesMemberDetail",
        component: () => import("../views/sales/member/_id/Dashboard.vue"),
      },
      {
        path: "edit",
        component: () => import("../views/sales/member/_id/Edit.vue"),
      },
      {
        path: "ticket",
        name: "SalesMemberTicketList",
        component: () => import("../views/sales/ticket/Index.vue"),
      },
      {
        path: "ticket/create",
        name: "SalesMemberTicketCreate",
        component: () => import("../views/sales/ticket/Create.vue"),
      },
      {
        path: "ticket/:ticket_id/edit",
        name: "SalesMemberTicketEdit",
        component: () => import("../views/sales/ticket/_id/Edit.vue"),
      },
      {
        path: "ticket/:ticket_id",
        name: "SalesMemberTicketDetail",
        component: () => import("../views/sales/ticket/_id/Index.vue"),
      },
      {
        path: "offer",
        name: "SalesMemberOfferList",
        component: () => import("../views/sales/offer/Index.vue"),
      },
      {
        path: "offer/create",
        name: "SalesMemberOfferCreate",
        component: () => import("../views/sales/offer/Create.vue"),
      },
      {
        path: "offer/:offer_id",
        name: "SalesMemberOfferDetail",
        component: () => import("../views/sales/offer/_id/Index.vue"),
      },
      {
        path: "proposal",
        name: "SalesMemberProposalList",
        component: () => import("../views/sales/proposal/Index.vue"),
      },
      {
        path: "proposal/create",
        name: "SalesMemberProposalCreate",
        component: () => import("../views/sales/proposal/Create.vue"),
      },
      {
        path: "proposal/:proposal_id",
        name: "SalesMemberProposalDetail",
        component: () => import("../views/sales/proposal/_id/Index.vue"),
      },
      {
        path: "proposal/:proposal_id/edit",
        name: "SalesMemberProposalEdit",
        component: () => import("../views/sales/proposal/_id/Edit.vue"),
      },
    ],
  },
  // Ticket
  {
    path: "/sales/ticket",
    name: "SalesTicketList",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/ticket/Index.vue"),
  },
  {
    path: "/sales/ticket/create",
    name: "SalesTicketCreate",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/ticket/Create.vue"),
  },
  {
    path: "/sales/ticket/:ticket_id",
    name: "SalesTicketDetail",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/ticket/_id/Index.vue"),
  },
  {
    path: "/sales/ticket/:ticket_id/edit",
    name: "SalesTicketEdit",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/ticket/_id/Edit.vue"),
  },

  //
  // Partner
  {
    path: "/sales/partner",
    name: "SalesPartner",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/partner/Index.vue"),
  },
  {
    path: "/sales/partner/create",
    name: "SalesPartnerCreate",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/partner/Create.vue"),
  },
  {
    path: "/sales/partner/:partner_id",
    component: () => import("../views/sales/partner/_id/Index.vue"),
    meta: { requiresAuthSale: true },
    children: [
      {
        path: "/",
        name: "SalesPartnerDashboard",
        component: () => import("../views/sales/partner/_id/Dashboard.vue"),
      },
      {
        path: "edit",
        name: "SalesPartnerEdit",
        component: () => import("../views/sales/partner/_id/Edit.vue"),
      },
      // Partnerに紐づくstaff
      {
        path: "staff",
        name: "SalesPartnerDetail",
        component: () => import("../views/sales/staff/Index.vue"),
      },
      {
        path: "staff/create",
        name: "SalesStaffCreate",
        component: () => import("../views/sales/staff/Create.vue"),
      },
      {
        path: "staff/:staff_id",
        name: "SalesStaffEdit",
        component: () => import("../views/sales/staff/_id/Edit.vue"),
      },
    ],
  },

  //
  // Proposal
  {
    path: "/sales/proposal",
    name: "SalesProposal",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/proposal/Index.vue"),
  },
  {
    path: "/sales/proposal/create",
    name: "SalesProposalCreate",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/proposal/Create.vue"),
  },
  {
    path: "/sales/proposal/:proposal_id",
    name: "SalesProposalDetail",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/proposal/_id/Index.vue"),
  },
  {
    path: "/sales/proposal/:proposal_id/edit",
    name: "SalesProposalEdit",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/proposal/_id/Edit.vue"),
  },

  // Offer
  {
    path: "/sales/offer",
    name: "SalesOffer",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/offer/Index.vue"),
  },
  {
    path: "/sales/offer/create",
    name: "SalesOfferCreate",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/offer/Create.vue"),
  },
  {
    path: "/sales/offer/:offer_id",
    name: "SalesOfferDetail",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/offer/_id/Index.vue"),
  },
  {
    path: "/sales/offer/:offer_id/edit",
    name: "SalesOfferEdit",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/offer//_id/Edit.vue"),
  },

  // Setting
  {
    path: "/sales/setting",
    name: "SalesSettings",
    meta: { requiresAuthSale: true },
    component: () => import("../views/sales/setting/Index.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuthCompany)) {
    if (!store.getters["auth/isCompany"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuthSale)) {
    if (!store.getters["auth/isSale"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuthMember)) {
    if (!store.getters["auth/isMember"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters["auth/isAuthorized"]) {
      store.commit("login/redirectUrl", to.fullPath);
      next({
        name: "Login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
